import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2 text-base leading-[1.2]" }
const _hoisted_2 = { class: "mb-4 text-2xl font-semibold leading-[1.2]" }

import { store } from "@/state/store";
import { $t } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeadlineLandingPage',
  setup(__props) {

if (store.landingPage.headerText === "") {
	store.landingPage.headerText = $t("landingPage.headline");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref($t)("landingPage.subheadline")), 1),
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(store).landingPage.headerText), 1)
  ], 64))
}
}

})